export const PUBLIC_URL = process.env.PUBLIC_URL;
export const REACT_APP_IS_INTL = process.env.REACT_APP_IS_INTL;
export const REACT_APP_STAT_ENV = process.env.REACT_APP_STAT_ENV;
export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const REACT_APP_RELEASE = process.env.REACT_APP_RELEASE;
export const REACT_APP_APP_KEY = process.env.REACT_APP_APP_KEY;
export const REACT_APP_APP_KEY_TEAM = process.env.REACT_APP_APP_KEY_TEAM;
export const REACT_APP_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const REACT_APP_WEB_API_HOST = process.env.REACT_APP_WEB_API_HOST;
export const REACT_APP_GENERATE_PIC_API_HOST = process.env.REACT_APP_GENERATE_PIC_API_HOST;
export const REACT_APP_USER_API_ORIGIN = process.env.REACT_APP_USER_API_ORIGIN;
export const REACT_APP_USER_API_ORIGIN_LOCAL = process.env.REACT_APP_USER_API_ORIGIN_LOCAL;
export const REACT_APP_USER_API_OFFICE_LOCAL = process.env.REACT_APP_USER_API_OFFICE_LOCAL;
export const REACT_APP_USER_API_OFFICE = process.env.REACT_APP_USER_API_OFFICE;
export const REACT_APP_IMAGE_EDITOR_LOCAL = process.env.REACT_APP_IMAGE_EDITOR_LOCAL;
export const REACT_APP_IMAGE_EDITOR = process.env.REACT_APP_IMAGE_EDITOR;
export const REACT_APP_USER_API_MAAT_LOCAL = process.env.REACT_APP_USER_API_MAAT_LOCAL;
export const REACT_APP_USER_API_MAAT = process.env.REACT_APP_USER_API_MAAT;
export const REACT_APP_USER_API_POLICY_LOCAL = process.env.REACT_APP_USER_API_POLICY_LOCAL;
export const REACT_APP_USER_API_POLICY = process.env.REACT_APP_USER_API_POLICY;
export const REACT_APP_POSTER_API_ORIGIN = process.env.REACT_APP_POSTER_API_ORIGIN;
export const isIntl = REACT_APP_IS_INTL === '1';
window.isIntl = isIntl;
